import React, { useRef, useState, useCallback } from 'react';
import List from '../grid.component';
import { useNavigate } from 'react-router-dom';
import ErrorMessage from '../shared/messages/errorMessage';
import { StatusColumnHandler, UserNameColumnHandler } from './service';
import ActionsComponent from '../shared/ActionsComponent';
import UserDetailsView from './userDetailsView';
import GridLayout from '../shared/gridLayout';
import { badge } from 'src/utils/statusColorsCode';

const UserGridData = (() => {
    const gridRef = useRef(null);
    const navigate = useNavigate();
    const [errorMsg, setErrorMsg] = useState(null)
    const [checkboxSelection, setCheckboxSelection] = useState([]);
    const [checkBoxData, setCheckBoxData] = useState({})
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    

    const viewUsersDetailsHandler = useCallback((flag, selectedData) => {
        setSelectedUserId(selectedData?.id);
        setIsModalOpen(flag);
    }, []);

    const closeModel = useCallback(() => {
        setIsModalOpen(false)
    }, [])
    const handleCheckboxChanges = useCallback(
        (prop, e) => {
            setErrorMsg(null);
            if (e.target?.checked) {
                const rowChecked = prop?.dataItem;
                let _selection = [...checkboxSelection];
                let idx = _selection.indexOf(rowChecked?.id);
                if (checkboxSelection) {
                    _selection = [];
                }
                if (idx > -1) {
                    _selection.splice(idx, 1);
                } else {
                    _selection.push(rowChecked?.id);
                }
                setCheckBoxData(rowChecked);
                setCheckboxSelection(_selection);
            } else {
                setCheckBoxData({});
                setCheckboxSelection([]);
            }
        }, [checkboxSelection, checkBoxData]);

    const userNameColumnHandler = (props) => {
        return (<UserNameColumnHandler data={props} viewUsersDetailsHandler={viewUsersDetailsHandler} />)
    }
    const statusColumnHandler = (props) => {
        return (<StatusColumnHandler data={props} badge={badge} />)
    }

    const handleToolBarActions = (action) => {
        if (!checkBoxData?.id && action !== 'add') {
            setErrorMsg("Please select one record!")
            return;
        }
        switch (action) {
            case 'add':
                navigate('/settings/users/add/null')
                break;
            case 'edit':
                navigate(`/settings/users/edit/${checkBoxData?.id}?key=${checkBoxData?.userName}`)
                break;
            default:
                return;
        }
    }

    const closeErrorHandler = useCallback(() => {
        setErrorMsg(null)
    }, [])

    const onActionClick = useCallback((key) => {
        handleToolBarActions(key)
    }, [checkBoxData])

    const customcells = {
        "": statusColumnHandler,
        "userName": userNameColumnHandler

    };

    const renderCustomCell = useCallback((props, column) => {
        if (customcells[column.field]) {
            return customcells[column.field](props);
        }
    }, [])

    return (
        <div className=''>
            <div className='flex gap-2 justify-end items-center mt-3'>
                <ActionsComponent serviceName={"CardsManageService.Settings"} onActionClick={onActionClick} targetTabName="Users" />
                <GridLayout />
            </div>
            {errorMsg && <ErrorMessage msg={errorMsg} onClose={closeErrorHandler} />}
            <div className="mt-3">
                <List
                    pSize={10}
                    url={process.env.REACT_APP_IDENTITY + `api/Custom/users/null`}
                    ref={gridRef}
                    className="custom-grid"
                    screenName={"Settings_Users"}
                    renderCustomCell={renderCustomCell}
                    handleSelection={handleCheckboxChanges}
                    showGridSelection={true}
                    selection={[checkBoxData?.id]}
                />
            </div>
            <UserDetailsView isModalOpen={isModalOpen} selectedUserId={selectedUserId} closeModel={closeModel} />
        </div>
    );
})
export default UserGridData;
